import React, { useEffect, useState, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { db, database, storage, auth } from '../firebase/logar';
import { lerAlunos, lerMensagensDoResponsavel, lerMensagensDoServidor, lerResponsavel, enviarMensagemParaResponsavel, enviarMensagemParaServidor, enviarMensagemEmMassa, enviarMensagemDoProfessor, enviarMensagemDoResponsavel, lerTodosAlunos, lerMensagensAprovar, aceitarMensagemAprovar, rejeitarMensagemAprovar } from '../firebase/mensagens';
import { lerDuvidasCentralAtendimento } from '../firebase/atendimento';
import Swal from 'sweetalert';
import '../css/Chat.css';
      
import emailjs from 'emailjs-com';

// ICONES
import { IonIcon } from '@ionic/react';
import * as IoniconsIcons from 'ionicons/icons';
import { wifiOutline, batteryFullOutline, cellularOutline, settings, peopleCircleOutline, arrowForward, personCircleOutline, closeOutline, logoWhatsapp, mail, chatboxEllipsesOutline, paperPlaneOutline, schoolOutline, bookOutline, libraryOutline, personOutline, checkmarkDone, checkmark, checkmarkDoneOutline, chatbubbleEllipses, chatbox, mailOutline, chatboxOutline, chatbubbleEllipsesOutline, alertCircleOutline, call, trash, peopleOutline, people, logoGoogle, close, options, eye, chatboxEllipses, image, statsChart, statsChartSharp } from 'ionicons/icons';

// COMPONENTS DE MENSAGENS
import { FormEnviarMensagemParaAlunos, FormEnviarMensagemEmMassa } from './components/general/FormMensagens';


const Chat = () => {

  const location = useLocation();

  const reload = async () => {
    await window.location.reload();
  }

  const abrirUrl = (url) => {
    window.open(url);
  }

  const ANO = localStorage.getItem('anoFiltrado');
  const ANOnormal = localStorage.getItem('ano');
  if (!ANO) {
    localStorage.setItem('anoFiltrado', ANOnormal)
  }
  
  // DADOS
  const storedResponsavel = localStorage.getItem('responsavel');
  const storedSerieResponsavel = localStorage.getItem('serie');
  const storedAlunoResponsavel = localStorage.getItem('aluno');
  const storedLogado = localStorage.getItem('logado');
  const storedUsuario = localStorage.getItem('usuario');  
  const [responsavel, setResponsavel] = useState(storedResponsavel ? storedResponsavel : null);
  const [serieResponsavel, setSerieResponsavel] = useState(storedSerieResponsavel ? storedSerieResponsavel : null);
  const [alunoResponsavel, setAlunoResponsavel] = useState(storedAlunoResponsavel ? storedAlunoResponsavel : null);
  const [logado, setLogado] = useState(storedLogado ? storedLogado.toLowerCase() : null);
  const [usuario, setUsuario] = useState(storedUsuario ? storedUsuario : null);
  
  if (!logado) {
    localStorage.clear();
    window.location.href = "../logar";
  }

  // RELOGIO
  const [horaAtual, setHoraAtual] = useState(new Date());

  useEffect(() => {
    
    const intervalId = setInterval(() => {
      setHoraAtual(new Date());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const formatDigit = (digit) => (digit < 10 ? '0' + digit : digit);

  const horas = formatDigit(horaAtual.getHours());
  const minutos = formatDigit(horaAtual.getMinutes());
  const segundos = formatDigit(horaAtual.getSeconds());

  // ADICIONAR SERIES
  const listaSeries = localStorage.getItem('series');
  const series = listaSeries ? JSON.parse(listaSeries) : [];
  const [serie, setSerie] = useState([]);
  
  // NOME DOS CHATS
  const [nomeChat, setNomeChat] = useState('');
  const [iconChat, setIconChat] = useState('');

  // PAGINAS ( SÉRIES )
  const [paginaSeries, setPaginaSeries] = useState(true);
  const [paginaResponsavel, setPaginaResponsavel] = useState(true);
  const [entrarEmContato, setEntrarEmContato] = useState(false);
  const [abrirMensagem, setAbrirMensagem] = useState(false);
  const [abrirMensagemProfessor, setAbrirMensagemProfessor] = useState(false);
  const [carregamentoMensagem, setCarregamentoMensagem] = useState(false);

  // PAGINAS ( SERVIÇOS )
  const [paginaServicos, setPaginaServicos] = useState(true);
  const [centralAtendimento, setCentralAtendimento] = useState(false);
  const [formEnviarMensagemMassa, setFormEnviarMensagemMassa] = useState(false);


  // GERENCIAR
  const [popupGerenciar, setPopupGerenciar] = useState(false);
  const [gerenciarResponsavel, setGerenciarResponsavel] = useState('');
  const [gerenciarOnesignalId, setGerenciarOnesignalId] = useState('');
  const [gerenciarSerie, setGerenciarSerie] = useState('');
  const [gerenciarServidor, setGerenciarServidor] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [mensagensOnline, setMensagensOnline] = useState([]);
  const [paginaMensagemDoProfessor, setPaginaMensagemDoProfessor] = useState(false);


  const [alunos, setAlunos] = useState([]);
  const [mdLerAlunos, setMdLerAlunos] = useState(false);
  
  const handleLerAlunos = async (serie) => {
    await setBtnVoltarInicio(true);
    await setMdLerAlunos(true);
    await setSerie(serie);
    await setAbrirLerAlunos(true);
    const resposta = await lerAlunos(serie);
    if (resposta.length === 0) {
      await setAlunos(false);  
    } else {
      await setAlunos(resposta);
    }
  }

  const handleGerenciarResponsavel = async (responsavel, serie, onesignalId) => {
    setPopupGerenciar(true);
    setGerenciarResponsavel(responsavel);
    setGerenciarSerie(serie);
    setGerenciarOnesignalId(onesignalId);
  };

  const handleFecharGerenciarResponsavel = async () => {
    await setPopupGerenciar(false);
  };
  
  const handleExcluirResponsavel = async (responsavel, serie) => {
    Swal({
      title: `Você deseja excluir o(a) responsável ${responsavel}?`,
      icon: 'warning',
      buttons: {
        confirm: 'Sim',
        cancel: 'Não',
      }
    }).then( async (response) => {
      if (response) {

        await db.collection(ANO)
        .doc('responsaveis')
        .collection(responsavel)
        .doc(responsavel).delete();

        await db.collection(ANO)
        .doc('series')
        .collection(serie)
        .doc(responsavel).delete(); 

        const chatRef = await database.ref(`${ANO}/chat/${serie}/${responsavel}`);
        await chatRef.remove();
        
        await Swal({
          title: `Responsável ${responsavel} excluído com sucesso!`,
          icon: 'success',
          buttons: {
            confirm: 'Ok',
          }
        }).then((response) => {
          window.location.reload();
        });

      }
    });
  };
  
  const [mensagemRapida, setMensagemRapida] = useState('');
  
  const [dadosResponsavel, setDadosResponsavel] = useState([]);
  const handleEntrarEmContato = async (responsavel, email) => {
    try {
      setEntrarEmContato(true);
      setPaginaSeries(false);
      setMdLerAlunos(false);
      handleFecharGerenciarResponsavel();
      const resposta = await lerResponsavel(responsavel);
      setDadosResponsavel(resposta);
    } catch (error) {
      console.log(error);
    }
  };

  const handleAbrirMensagem = async (responsavel, serie, servidor) => {
    setCarregamentoMensagem(true);
    try {
      setAbrirMensagem(true);
      if (logado === 'responsavel') {
        setPaginaResponsavel(false);
        if (servidor === 'direcao') {
          setNomeChat('Direção');
        } else if (servidor === 'coordenacao') {
          setNomeChat('Coordenação');
        } else if (servidor === 'professor') {
          setNomeChat('Professores');
        }
        setGerenciarServidor(servidor);
        const mensagensLidas = await lerMensagensDoServidor(responsavel, serie, servidor);
        if (mensagensLidas && mensagensLidas.length > 0) {
          const mensagensOrdenadas = mensagensLidas.sort((a, b) => (a.hora || 0) - (b.hora || 0));
          setMensagensOnline(mensagensOrdenadas);
        } else {
          setCarregamentoMensagem(false);
        }
      } else {
        setPaginaSeries(false);
        setMdLerAlunos(false);
        setNomeChat(responsavel);
        handleFecharGerenciarResponsavel();
        const mensagensLidas = await lerMensagensDoResponsavel(responsavel, serie, servidor);
        if (mensagensLidas && mensagensLidas.length > 0) {
          const mensagensOrdenadas = mensagensLidas.sort((a, b) => (a.hora || 0) - (b.hora || 0));
          setMensagensOnline(mensagensOrdenadas);
        } else {
          setCarregamentoMensagem(false);
        }
      }  
    } catch (error) {
      console.log(error);
    }
  };

  const [abrirLerAlunos, setAbrirLerAlunos] = useState(false);
  const handleAbrirMensagemProfessor = async (responsavel, serie, servidor) => {
    try {
      setAbrirMensagemProfessor(true);
      setPaginaResponsavel(false);
      setAbrirLerAlunos(false);
      setNomeChat('Professores');
      setGerenciarServidor(servidor);
      const mensagens = await lerMensagensDoServidor(responsavel, serie, servidor);
      const mensagensOrdenadas = await mensagens.sort((a, b) => (a.hora || 0) - (b.hora || 0));
      setMensagensOnline(mensagensOrdenadas);
    } catch (error) {
      console.log(error);
    }
  };

  const enviarEmail = async (email) => {
    try {
      const mensagem = mensagemRapida;
      const templateParams = {
        to_email: email,
        from_email: 'e.e.prof.leticia@gmail.com',
        subject: 'Mensagem da Escola Letícia',
        message_html: mensagem,
        content_type: 'text/html',
      };
  
      emailjs.send('service_rruib4h', 'template_2gse4we', templateParams, 'uB7yULNAo_fkSNq6T')
        .then((response) => {
          console.log('E-mail enviado com sucesso:', response);
        })
        .catch((error) => {
          console.error('Erro ao enviar e-mail:', error);
        });
    } catch (error) {
      console.log('Erro ao enviar e-mail:', error.message);
    }
  };

  const handleEnviarMensagemParaResponsavel = async () => {
    try {
      enviarMensagemParaResponsavel(gerenciarResponsavel, gerenciarSerie, logado, mensagem, gerenciarOnesignalId);
    } catch (error) {
      console.log(error);
    }
  };

  const handleEnviarMensagemParaServidor = async () => {
    try {
      enviarMensagemParaServidor(responsavel, serieResponsavel, gerenciarServidor, mensagem);
    } catch (error) {
      console.log(error);
    }
  };


  
  useEffect(() => {

    const abrirMensagemAutomaticamente = async (usuario, serie) => {
      try {
        const alunosList = await lerAlunos(serie);
        
        if (alunosList.length > 0) {
          for (const dado of alunosList) {
            if (dado.responsavel === usuario) {
              setGerenciarResponsavel(dado.responsavel);
              setGerenciarSerie(dado.serie);
              setGerenciarOnesignalId(dado.onesignalId); // Define onesignalId antes de chamar a função
              
              await handleAbrirMensagem(dado.responsavel, dado.serie, logado);
              return true; // Retorna true se encontrar um aluno correspondente
            }
          }
        }
    
        
      } catch (error) {
        console.log(error);
        return false; // Retorna false em caso de erro
      }
    };
    
    // Acesse os parâmetros da URL
    const searchParams = new URLSearchParams(location.search);
    const usuarioParam = searchParams.get('usuario');
    const serieParam = searchParams.get('serie');
    
      if (usuarioParam === 'direcao' && logado === 'responsavel') {
        setBtnVoltarInicioResponsavel(true);
        handleAbrirMensagem(responsavel, serieResponsavel, 'direcao');
      } else if (usuarioParam === 'coordenacao' && logado === 'responsavel') {
        setBtnVoltarInicioResponsavel(true);
        handleAbrirMensagem(responsavel, serieResponsavel, 'coordenacao')
      } else if (usuarioParam === 'professor' && logado === 'responsavel') {
        setBtnVoltarInicioResponsavel(true);
        handleAbrirMensagemProfessor(responsavel, serieResponsavel, 'professor')
      } else if (usuarioParam && serieParam) {
        if (logado !== 'professor') {
          setBtnVoltarInicio(true);
          abrirMensagemAutomaticamente(usuarioParam, serieParam);
        } else {
          setBtnVoltarInicioProfessor(true);
          setPaginaMensagemDoProfessor(true);
          handleAbrirMensagemProfessor(usuarioParam, serieParam, 'professor');
        }
        
        // Faça algo com o valor de 'usuarioParam'
        console.log('Valor do parâmetro USUÁRIO:', usuarioParam);
        console.log('Valor do parâmetro SÉRIE:', serieParam);
      }

  }, [location.search]);
  

  // CENTRAL DE ATENDIMENTO
  const [duvidasCentralAtendimento, setDuvidasCentralAtendimento] = useState([]);

  const handleCentralAtendimento = async () => {
    try {
      setBtnVoltarInicio(true);
      setCentralAtendimento(true);
      const duvidas = await lerDuvidasCentralAtendimento();
      console.log(duvidas)
      setDuvidasCentralAtendimento(duvidas);
    } catch (error) {
      console.log(error);
    }
  };

  const excluirDuvida = async (id) => {
    Swal({
      title: 'Você deseja excluir mesmo?',
      icon: 'warning',
      buttons: {
        confirm: 'Sim',
        cancel: 'Não',
      },
    }).then( async (res) => {
      if (res) {
        await db.collection(ANO)
        .doc('duvidas')
        .collection('pais')
        .doc(id).delete().then((resposta) => {
          Swal({
            title: 'Dúvida excluida com sucesso!',
            icon: 'success',
            buttons: {
              confirm: 'Ok',
            },
          }).then((response) => {
            window.location.reload();
          })
        });
      }
    });
  };

  const handleFormEnviarMensagemMassa = async () => {
    try {
      setBtnVoltarInicio(true);
      setFormEnviarMensagemMassa(true);
    } catch (error) {
      console.log(error);
    }
  };

  const [todosOsAlunos, setTodosOsAlunos] = useState(false);
  const [buscaAluno, setBuscaAluno] = useState('');
  
  // BUSCA MAIS AVANÇADA
  const [buscaDados, setBuscaDados] = useState('');
  const [buscaResponsabilidade, setBuscaResponsabilidade] = useState('');
  const [buscaRa, setBuscaRa] = useState('');
  const todosAlunosStorage = localStorage.getItem('todosAlunos');
  const todosAlunos = todosAlunosStorage ? JSON.parse(todosAlunosStorage) : [];
  const handleTodosOsAlunos = async () => {
    try {
      setBtnVoltarInicio(true);
      setTodosOsAlunos(true);
      const alunosList = await lerTodosAlunos();
      if (alunosList.length > 0) {
        localStorage.setItem('todosAlunos', JSON.stringify(alunosList));
      } else {
        localStorage.setItem('todosAlunos', []);
      }
      
    } catch (error) {
      console.log(error);
    }
  };
  
  // INPUTS DOS FORMULARIOS
  const [destinatario, setDestinatario] = useState('');
  const [mensagemEmMassa, setMensagemEmMassa] = useState('');

  const handleEnviarMensagemEmMassa = async () => {
    try {
      const enviar = await enviarMensagemEmMassa(destinatario, mensagemEmMassa);      
      if (enviar) {
        Swal({
          title: 'Mensagem em massa enviado com sucesso!',
          icon: 'success',
          buttons: {
            confirm: 'Ok',
          },
        });
      } else {
        Swal({
          title: 'Erro ao enviar mensagem!',
          icon: 'error',
          buttons: {
            confirm: 'Ok',
          },
        });
      }
    } catch (error) {
      console.log(error);
    }
  };


  // APROVAR MENSAGENS DOS PROFESSORES
  const [aprovarMensagemDoProfessor, setAprovarMensagemDoProfessor] = useState(false);
  const [aprovarMensagemDoResponsavel, setAprovarMensagemDoResponsavel] = useState(false);
  const [mensagensAprovar, setMensagensAprovar] = useState([]);

  const handleAprovarMensagemDoProfessor = async () => {
    try {
      setBtnVoltarInicio(true);
      setAprovarMensagemDoProfessor(true);
      const mensagensAprovarList = await lerMensagensAprovar('professor');
      setMensagensAprovar(mensagensAprovarList);
    } catch (error) {
      console.log(error);
    }
  };

  const handleAprovarMensagemDoResponsavel = async () => {
    try {
      setBtnVoltarInicio(true);
      setAprovarMensagemDoResponsavel(true);
      const mensagensAprovarList = await lerMensagensAprovar('responsavel');
      setMensagensAprovar(mensagensAprovarList);
    } catch (error) {
      console.log(error);
    }
  };

  // FORMULARIO DE MENSAGEM DO PROFESSOR
  const [abrirFormMensagemProfessor, setAbrirFormMensagemProfessor] = useState(false);
  const [abrirFormMensagemResponsavel, setAbrirFormMensagemResponsavel] = useState(false);
  const [formMensagemProfessorSerie, setFormMensagemProfessorSerie] = useState('');
  const [formMensagemProfessorAluno, setFormMensagemProfessorAluno] = useState('');
  const [formMensagemProfessorMensagem, setFormMensagemProfessorMensagem] = useState('');
  const [formMensagemResponsavelMensagem, setFormMensagemResponsavelMensagem] = useState('');
  

  const handleFormMensagemProfessor = () => {
    setAbrirFormMensagemProfessor(true);
  }

  const handleFormMensagemResponsavel = () => {
    setAbrirFormMensagemResponsavel(true);
    setPaginaResponsavel(false);
  }

  const [lerSeries, setLerSeries] = useState(false);

  const handleLerSeries = async () => {
    setLerSeries(true);
    await db.collection(ANO)
    .doc('restrito')
    .collection('series')
    .onSnapshot((data) => {
      const seriesList = data.docs.map((val) => val.id);
      localStorage.setItem('series', JSON.stringify(seriesList));
    });
  }


  // APROVAR FOTO DE PERFIL
  const lerAprovarFotos = async () => {
    
    const fotos = [];
    
    const ler = new Promise( async (resolve, reject) => {
      try {
        await db.collection(ANO)
        .doc('carometro')
        .collection('pendente')
        .onSnapshot((data) => {
          data.docs.map( async (val) => {
            const responsavel = val.id;
            const imagem = val.data().imagem;
            const storageRef = await storage.ref(`${ANO}/responsaveis/${responsavel}/${imagem}`);
            await storageRef.getDownloadURL()
              .then((url) => {
                  fotos.push({
                    urlImagem: url,
                    nomeImagem: imagem,
                    responsavel: responsavel,
                  });
              })
          });
          resolve(fotos);
          console.log(fotos)
        });
      } catch (error) {
        console.log(error);
      }
    });

    return ler;
  };

  const aceitarFotoDePerfil = async (responsavel, nomeImagem) => {
    const enviar = new Promise( async (resolve, reject) => {
      await Swal({
        title: `Você ACEITA essa foto de perfil?`,
        icon: 'warning',
        buttons: {
          confirm: 'Sim',
          cancel: 'Não',
        },
      }).then( async (response) => {
        if (response) {
          try {
            await db.collection(ANO)
            .doc('carometro')
            .collection('pendente')
            .doc(responsavel).delete();
  
            await db.collection(ANO)
            .doc('responsaveis')
            .collection(responsavel)
            .doc(responsavel).update({
              imagem: nomeImagem,
            });
          } catch (error) {
            console.log(error);
          } finally {
            await Swal({
              title: `Foto de perfil aceita!`,
              icon: 'success',
              buttons: {
                confirm: 'Ok',
              },
            }).then((res) => {
              window.location.reload();
            })
          }
        }
      });
    });

    return enviar;
  };

  const rejeitarFotoDePerfil = async (responsavel, nomeImagem) => {
    const rejeitar = new Promise( async (resolve, reject) => {
      await Swal({
        title: `Você REJEITA essa foto de perfil?`,
        icon: 'warning',
        buttons: {
          confirm: 'Sim',
          cancel: 'Não',
        },
      }).then( async (response) => {
        if (response) {
          try {
            await db.collection(ANO)
            .doc('carometro')
            .collection('pendente')
            .doc(responsavel).delete();
    
            const storageRef = await storage.ref(`${ANO}/responsaveis/${responsavel}/${nomeImagem}`);
            await storageRef.delete();
          } catch (error) {
            console.log(error);
          } finally {
            await Swal({
              title: `Foto de perfil rejeitada!`,
              icon: 'success',
              buttons: {
                confirm: 'Ok',
              },
            }).then((res) => {
              window.location.reload();
            })
          }
        }
      });
    });

    return rejeitar;
  };

  const [aprovarFotoDePerfil, setAprovarFotoDePerfil] = useState(false);
  const [fotosAprovar, setFotosAprovar] = useState([]);
  const handleAprovarFotoDePerfil = async () => {
    try {
      setBtnVoltarInicio(true);
      setAprovarFotoDePerfil(true);
      const fotosDePerfil = await lerAprovarFotos();
      setFotosAprovar(fotosDePerfil);
    } catch (error) {
      console.log(error);
    }
  };

  // PLANILHAS
  const [planilhas, setPlanilhas] = useState(false);
  const [planilhasLer, setPlanilhasLer] = useState(false);
  const [dadosPlanilhas, setDadosPlanilhas] = useState([]);
  
  const handlePlanilhas = async () => {
    try {
      setBtnVoltarInicio(true);
      setPlanilhas(true);
      const planilhas = await lerPlanilhas();
      console.log(planilhas)
      setDadosPlanilhas(planilhas);
    } catch (error) {
      console.log(error);
    }
  };

  const [listaTelefone, setListaTelefone] = useState(false);
  const [listaTelefoneLer, setListaTelefoneLer] = useState(false);
  const [dadosListaTelefone, setDadosListaTelefone] = useState([]);
  
  const handleListaTelefone = async () => {
    try {
      setBtnVoltarInicio(true);
      setListaTelefone(true);
      const lista = await lerPlanilhas();
      var telefones = [];

      const promiseData = await lista.map( async (data, index) => {
        const serie = data.nome;
        const dado = data.json;
        const dados = await arrumarDadosPlanilhas(JSON.parse(dado));
        const telefonesDados = await coletarTelefones(serie, dados);
        
        telefones.push(telefonesDados);
      });

      const resposta = await Promise.all(promiseData);
      if (resposta) {
        setDadosListaTelefone(telefones);
        console.log(telefones);
      }

    } catch (error) {
      console.log(error);
    }
  };


  const excluirPlanilha = async (nome) => {
    
    const excluir = new Promise( async (resolve, reject) => {
        try {
            await Swal({
                title: `Você deseja excluir a planílha '${nome}'?`,
                icon: 'warning',
                buttons: {
                    confirm: 'Sim',
                    cancel: 'Não',
                },
            }).then( async (response) => {

                if (response) {

                  await db.collection(ANO)
                  .doc('planilhas')
                  .collection('planilhas')
                  .doc(nome).delete().then( async (res) => {
                      await Swal({
                          title: 'planílha excluída com sucesso',
                          icon: 'success',
                      }).then((res) => {
                        window.location.reload();
                      });
                  });

                }

            })
            
            
        } catch (error) {
            console.error('Erro ao ler evento:', error);
            throw error;
            reject(error);
        }
    });
    
    return excluir;
  };

  

  const lerPlanilhas = async () => {
    var planilhas = [];

    const lerPlanilhas = new Promise( async (resolve, reject) => {
        try {
            await db.collection(ANO)
            .doc('planilhas')
            .collection('planilhas')
            .onSnapshot((data) => {
                data.docs.map((val) => {
                    const nome = val.id;
                    const json = val.data().json;
                    planilhas.push({
                        nome: nome,
                        json: json,
                    });
                });
                resolve(planilhas);
            });
        } catch (error) {
            console.error('Erro ao ler evento:', error);
            throw error;
            reject(error);
        }
    });
    
    return lerPlanilhas;
  };

  const handleLerDadosPlanilhas = async (dados) => {
    setPlanilhasLer(true);
    const lista = await arrumarDadosPlanilhas(JSON.parse(dados));
    setDadosPlanilhas(lista);
  }

  const arrumarDadosPlanilhas = async (data) => {
    var lista = [];
    if (data.length > 0) {
        var colunas = Object.values(data[0]).length;
        var coluns = data[0];

        // LER LINHA QUE SE REFERE A COLUNAS
        await data.map((row, index) => {
            var obj = {}
            Object.entries(row).map(([key, value]) => {
                const nome = coluns[key];
                const valor = value;
                obj[nome] = valor;
            })
            lista.push(obj);
        });
        
        await lista.shift();
        
        return lista;
    }
  }

  
  const coletarTelefones = async (serie, data) => {
    var telefones = [];
    if (data.length > 0) {
      
        await data.map((val, index) => {
            const email = val["E-mail"];
            const numeroDeTelefones = [val.telefone, val.Telefone, val.telefone1, val.telefone2, val.telefone3]
            .filter(Boolean) // Remove valores undefined, null ou empty strings
            .join(', ');
            console.log(telefones);
            const aluno = val.Aluno || val.aluno || val.nome;
            const responsavel = val["Responsável"] ? val["Responsável"] : val["ResponsÃ¡vel"] ? val["ResponsÃ¡vel"] : 'Não encontrado!';
            
            telefones.push({
              telefone: numeroDeTelefones,
              aluno,
              responsavel,
              email,
            });
        });
        
        return { [serie]: telefones };
    }
  }


  const handleLerDadosListaTelefone = async (serie, dados) => {
    console.log(dados)
    setListaTelefoneLer(true);
    setGerenciarSerie(serie);
    setDadosListaTelefone(dados);
  }


  const [ResponsavelEnviarMsgRapida, setResponsavelEnviarMsgRapida] = useState('');
  const [AlunoEnviarMsgRapida, setAlunoEnviarMsgRapida] = useState('');


  const atualizarMensagemRapida = async (aluno, responsavel) => {
    const novaMensagemAluno = await mensagemRapida.replace(/#aluno/g, aluno);
    const novaMensagem = await novaMensagemAluno.replace(/#responsavel/g, responsavel);
    return novaMensagem.replace(/\u0083/g, '');
  }


  // BOTÕES DE VOLTAR

  // PARA SERVIDOR
  const [btnVoltarInicio, setBtnVoltarInicio] = useState(false);
  const [btnVoltarTodosOsAlunos, setBtnVoltarTodosOsAlunos] = useState(false);
  const [btnVoltarDadosDosAlunos, setBtnVoltarDadosDosAlunos] = useState(false);
  const [btnVoltarListaDeTelefones, setBtnVoltarListaDeTelefones] = useState(false);
  const [btnVoltarAlunosDaSerie, setBtnVoltarAlunosDaSerie] = useState(false);
    
  // PARA RESPONSÁVEL
  const [btnVoltarInicioResponsavel, setBtnVoltarInicioResponsavel] = useState(false);
  
  // PARA RESPONSÁVEL
  const [btnVoltarInicioProfessor, setBtnVoltarInicioProfessor] = useState(false);
  const [btnVoltarAlunosDaSerieProfessor, setBtnVoltarAlunosDaSerieProfessor] = useState(false);
  

  // VTR
  const voltarInicio = () => {
    const voltar = new Promise((resolve, reject) => {
      setBtnVoltarInicio(false);
      setBtnVoltarTodosOsAlunos(false);
      setEntrarEmContato(false);
      setMdLerAlunos(false);
      setAbrirMensagem(false);
      setAlunos([]);
      setPaginaSeries(false);
      setTodosOsAlunos(false);
      setFormEnviarMensagemMassa(false);
      setCentralAtendimento(false);
      setPlanilhas(false);
      setPlanilhasLer(false);
      setListaTelefone(false);
      setAprovarMensagemDoProfessor(false);
      setAprovarMensagemDoResponsavel(false);
      setAprovarFotoDePerfil(false);
      setNomeChat('');
    });

    return voltar;
  }

  const voltarInicioResponsavel = () => {
    const voltar = new Promise((resolve, reject) => {
      setBtnVoltarInicioResponsavel(false);
      setAbrirMensagemProfessor(false);
      setAbrirMensagem(false);
      setAbrirFormMensagemResponsavel(false);
      setPaginaResponsavel(true);
      setNomeChat('');
    });

    return voltar;
  }

  const voltarInicioProfessor = () => {
    const voltar = new Promise((resolve, reject) => {
      setBtnVoltarInicioProfessor(false);
      setPaginaSeries(false);
      setAbrirMensagemProfessor(false);
      setAbrirMensagem(false);
      setAbrirFormMensagemProfessor(false);
      setPaginaMensagemDoProfessor(false);
      setPaginaServicos(true);
      setAlunos([]);
      setNomeChat('');
    });

    return voltar;
  }

  const voltarAlunosDaSerieProfessor = () => {
    const voltar = new Promise((resolve, reject) => {
      setBtnVoltarInicioProfessor(true);
      setBtnVoltarAlunosDaSerieProfessor(false);
      setPaginaSeries(false);
      setAbrirMensagemProfessor(false);
      setAbrirMensagem(false);
      setAbrirFormMensagemProfessor(false);
      setPaginaMensagemDoProfessor(false);
      setLerSeries(true);
      setPaginaServicos(false);
      setAbrirLerAlunos(true);
      setNomeChat('');
    });

    return voltar;
  }

  const voltarTodosOsAlunos = () => {
    const voltar = new Promise((resolve, reject) => {
      setBtnVoltarInicio(true);
      setBtnVoltarTodosOsAlunos(false);
      setBtnVoltarListaDeTelefones(false);
      setBtnVoltarDadosDosAlunos(false);
      setBtnVoltarAlunosDaSerie(false);
      setEntrarEmContato(false);
      setTodosOsAlunos(true);
      setAbrirMensagem(false);
      setPlanilhasLer(false);
      setNomeChat('');
    });

    return voltar;
  }

  const voltarAlunosDaSerie = () => {
    const voltar = new Promise((resolve, reject) => {
      setBtnVoltarInicio(true);
      setBtnVoltarTodosOsAlunos(false);
      setBtnVoltarAlunosDaSerie(false);
      setBtnVoltarListaDeTelefones(false);
      setBtnVoltarDadosDosAlunos(false);
      
      setEntrarEmContato(false);
      setAbrirMensagem(false);
      setMdLerAlunos(true);
      setNomeChat('');
    });

    return voltar;
  }

  const voltarDadosDosAlunos = () => {
    const voltar = new Promise( async (resolve, reject) => {
      await handlePlanilhas();
      setBtnVoltarInicio(true);
      setBtnVoltarTodosOsAlunos(false);
      setBtnVoltarAlunosDaSerie(false);
      setBtnVoltarDadosDosAlunos(false);
      setBtnVoltarListaDeTelefones(false);
      setPlanilhasLer(false);
      setNomeChat('');
    });

    return voltar;
  }

  const voltarListaDeTelefones = () => {
    const voltar = new Promise( async (resolve, reject) => {
      await handleListaTelefone();
      setBtnVoltarInicio(true);
      setBtnVoltarTodosOsAlunos(false);
      setBtnVoltarDadosDosAlunos(false);
      setBtnVoltarListaDeTelefones(false);
      
      setListaTelefoneLer(false);
      setNomeChat('');
    });

    return voltar;
  }

  return (
    <main className="container-chat">
      <div className="before">
        <p id="hora">
          {horas}:{minutos}:{segundos}
        </p>

        <div className="flex">
          <IonIcon icon={wifiOutline} />
          <IonIcon icon={cellularOutline} />
          <IonIcon icon={batteryFullOutline} />
        </div>
      </div>

      <header className="local">

        {/* PARA SERVIDOR */}
        {btnVoltarInicio && !btnVoltarTodosOsAlunos && !btnVoltarDadosDosAlunos ? (
          <IonIcon onClick={voltarInicio} icon={IoniconsIcons.arrowBack} />
        ) : (
          <></>
        )}
        {btnVoltarTodosOsAlunos && !btnVoltarInicio && !btnVoltarDadosDosAlunos ? (
          <IonIcon onClick={voltarTodosOsAlunos} icon={IoniconsIcons.arrowBack} />
        ) : (
          <></>
        )}
        {btnVoltarAlunosDaSerie && !btnVoltarInicio && !btnVoltarDadosDosAlunos ? (
          <IonIcon onClick={voltarAlunosDaSerie} icon={IoniconsIcons.arrowBack} />
        ) : (
          <></>
        )}
        {btnVoltarDadosDosAlunos && !btnVoltarInicio && !btnVoltarTodosOsAlunos ? (
          <IonIcon onClick={voltarDadosDosAlunos} icon={IoniconsIcons.arrowBack} />
        ) : (
          <></>
        )}
        {btnVoltarListaDeTelefones && !btnVoltarInicio && !btnVoltarTodosOsAlunos ? (
          <IonIcon onClick={voltarListaDeTelefones} icon={IoniconsIcons.arrowBack} />
        ) : (
          <></>
        )}

        {/* PARA RESPONSÁVEL */}
        {btnVoltarInicioResponsavel ? (
          <IonIcon onClick={voltarInicioResponsavel} icon={IoniconsIcons.arrowBack} />
        ) : (
          <></>
        )}

        {/* PARA PROFESSOR */}
        {btnVoltarInicioProfessor ? (
          <IonIcon onClick={voltarInicioProfessor} icon={IoniconsIcons.arrowBack} />
        ) : (
          <></>
        )}
        {btnVoltarAlunosDaSerieProfessor ? (
          <IonIcon onClick={voltarAlunosDaSerieProfessor} icon={IoniconsIcons.arrowBack} />
        ) : (
          <></>
        )}
        
        {nomeChat !== "" && nomeChat ? (
          <div className="width-auto">
            {nomeChat === 'Direção' ? (
              <IonIcon style={{cursor: 'default', color: 'var(--light)'}} icon={schoolOutline} />
            ) : nomeChat === 'Coordenação' ? (
              <IonIcon style={{cursor: 'default', color: 'var(--light)'}} icon={bookOutline} />
            ) : nomeChat === 'Professores' ? (
              <IonIcon style={{cursor: 'default', color: 'var(--light)'}} icon={libraryOutline} />
            ) : (
              <IonIcon style={{cursor: 'default', color: 'var(--light)'}} icon={personCircleOutline} />
            )}
            <h1>{nomeChat}</h1>
          </div>
        ) : (
          <h1>Mensagens</h1>
        )}
        <Link to="/app/configuracoes">
          <IonIcon icon={settings} />
        </Link>

      </header>

      {logado === 'responsavel' ? (
        <section className="content-chat">
          {/* CONTEUDO PARA RESPONSAVEL */}
            {paginaResponsavel && (
              <div className="width-100">
                <div className="decoracao mt-35 mb-10">
                    <p>Mensagens</p>
                </div>
                
                <div className="lista-chat">
                  <ul>
                    <li onClick={() => {
                      handleAbrirMensagem(responsavel, serieResponsavel, 'direcao');
                      setBtnVoltarInicioResponsavel(true);
                    }}>
                      <IonIcon icon={schoolOutline} />
                      <h1>Direção</h1>
                      <IonIcon icon={arrowForward} />
                    </li>
                    <li onClick={() => {
                      handleAbrirMensagem(responsavel, serieResponsavel, 'coordenacao');
                      setBtnVoltarInicioResponsavel(true);
                    }}>
                      <IonIcon icon={bookOutline} />
                      <h1>Coordenação</h1>
                      <IonIcon icon={arrowForward} />
                    </li>
                    <div className="decoracao mt-25 mb-30">
                      <p>Comunicados</p>
                    </div>
                    <li onClick={() => {
                      handleFormMensagemResponsavel();
                      setBtnVoltarInicioResponsavel(true);
                    }}>
                      <IonIcon icon={libraryOutline} />
                      <h1>Enviar comunicado para professores</h1>
                      <IonIcon icon={arrowForward} />
                    </li>
                    <li onClick={() => {
                      handleAbrirMensagemProfessor(responsavel, serieResponsavel, 'professor');
                      setBtnVoltarInicioResponsavel(true);
                    }}>
                      <IonIcon icon={eye} />
                      <h1>Ler comunicados dos professores</h1>
                      <IonIcon icon={arrowForward} />
                    </li>
                  </ul>
                </div>

              </div>
            )}

            {abrirFormMensagemResponsavel && (
              <div style={{margin: '10px 0px 0px 0px'}} className='form-tecvit'>
                
                <h1>Enviar comunicado para professores</h1>
                
                <div className='flex'>
                  <textarea onChange={(e) => setFormMensagemResponsavelMensagem(e.target.value)} placeholder=' '></textarea>
                  <label>Mensagem</label>
                </div>

                <div className='flex'>
                  <button onClick={() => enviarMensagemDoResponsavel(serieResponsavel, alunoResponsavel, formMensagemResponsavelMensagem, responsavel)}>Enviar Mensagem</button>  
                </div>
                
              </div>
            )}

        </section>  
      ) : logado === 'direcao' || logado === 'coordenacao' ? (
        <section className="content-chat">
          {/* CONTEUDO PARA SERVIDOR */}

          {entrarEmContato && (
            <div className="dados-chat">
              
              <div className="decoracao">
                <p>Dados do Perfi</p>
              </div>

              {dadosResponsavel.length > 0 ? (
                dadosResponsavel.map((item, index) => {
                  const WhatsappLink = `https://wa.me/${item.telefoneResponsavel}?text=${encodeURIComponent(mensagemRapida)}`;
                  const SmsLink = `sms://${item.telefoneResponsavel}?body=${encodeURIComponent(mensagemRapida)}`;
                  const EmailLink = `mailto:${item.email}?subject=Mensagem da Escola Letícia de Godoy Bueno Carvalho Lopes&?body=${encodeURIComponent(mensagemRapida)}`; 
                  const GmailLink = `https://mail.google.com/mail/u/0/?fs=1&tf=cm&source=mailto&su=Mensagem+da+Escola+Let%C3%ADcia+de+Godoy+Bueno+Carvalho+Lopes&to=${item.email}&body=${encodeURIComponent(mensagemRapida)}`;
                  
                return (
                  <div className="width-100">
                    
                    <table>
                      <tr>
                        <td className='principal'><strong>Foto de Perfil</strong></td>
                        <td className='flex'>
                          {!item.fotoDePerfil ? (
                            <IonIcon icon={personCircleOutline} />
                          ) : (
                            <img src={item.fotoDePerfil} />
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td className='principal'><strong>Responsável</strong></td>
                        <td><p>{item.responsavel}</p></td>
                      </tr>
                      <tr>
                        <td className='principal'><strong>Aluno</strong></td>
                        <td><p>{item.aluno}</p></td>
                      </tr>
                      <tr>
                        <td className='principal'><strong>Senha</strong></td>
                        <td><p>{item.senha}</p></td>
                      </tr>
                      <tr>
                        <td className='principal'><strong>Serie</strong></td>
                        <td><p>{item.serie}</p></td>
                      </tr>
                      <tr>
                        <td className='principal'><strong>E-mail</strong></td>
                        <td><p style={{wordBreak: 'break-all'}}>{item.email}</p></td>
                      </tr>
                      <tr>
                        <td className='principal'><strong>Telefone do Responsável</strong></td>
                        <td><p>{item.telefoneResponsavel}</p></td>
                      </tr>
                      <tr>
                        <td className='principal'><strong>Telefone do Aluno</strong></td>
                        <td><p>{item.telefoneAluno}</p></td>
                      </tr>
                      <tr>
                        <td className='principal'><strong>Notificação Id</strong></td>
                        <td><p>{item.onesignalId}</p></td>
                      </tr>
                      <tr>
                        <td className='principal'><strong>Usuário Sed</strong></td>
                        <td><p>{item.ra}</p></td>
                      </tr>
                      <tr>
                        <td className='principal'><strong>Senha Sed</strong></td>
                        <td><p>{item.senhaSed}</p></td>
                      </tr>
                      <tr>
                        <td className='principal'><strong>Data de Nascimento</strong></td>
                        <td><p>{item.nascimentoAluno}</p></td>
                      </tr>
                    </table>


                  {item.telefoneResponsavel || item.email ? (
                    <div className="width-100">
    
                      <div className="decoracao">
                          <p>Entrar em Contato</p>
                      </div>

                      <section className="card-contato">
                        <div className="titulo">
                          <IonIcon icon={chatbubbleEllipses} />
                          <h1>Mensagem Rápida</h1>
                        </div>
                        <div className="botoes">
                          <select onChange={(e) => setMensagemRapida(e.target.value)}>
                            <option value="">Escolha um mensagem</option>
                            <option value={`Olá ${item.responsavel},

Somos a Escola Letícia de Godoy e estamos entrando em contato para 
confirmar se você é o responsável pelo aluno(a) ${item.aluno}?

Informamos que o estudante ${item.aluno}, cujo responsável está vinculado a este número de telefone, não está presente hoje na escola. 
Caso haja alguma dúvida ou necessidade de informações adicionais, por favor, 
não hesite em entrar em contato com a secretaria da escola.
16 3324 4623  /   16 3324 2256    /   16 991190322
Obrigado.`}>
                              Aluno não presente na escola
                            </option>

                            <option value={`Olá ${item.responsavel},

Somos a Escola Letícia de Godoy e estamos entrando em contato para 
confirmar se você é o responsável pelo aluno(a) ${item.aluno}?

E. E. Profª. Letícia de Godoy comunica:
Tentamos entrar em contato sem sucesso, assim que possível, favor retornar através dos telefones da secretaria.
16 3324 4623  /   16 3324 2256    /   16 991190322
Obrigado.`}>
                              Contato sem sucesso
                            </option>

                            <option value={`Olá ${item.responsavel},

Somos a Escola Letícia de Godoy e estamos entrando em contato para 
confirmar se você é o responsável pelo aluno(a) ${item.aluno}?

E. E. Profª. Letícia de Godoy comunica:
Recado enviado através do estudante, favor verificar o documento. 
Em caso de dúvidas estamos à disposição.
16 3324 4623  /   16 3324 2256    /   16 991190322
Obrigado.`}>
                              Documento enviado através do aluno
                            </option>

                            <option value={`Olá ${item.responsavel},

Somos a Escola Letícia de Godoy e estamos entrando em contato para 
confirmar se você é o responsável pelo aluno(a) ${item.aluno}?

E. E. Profª. Letícia de Godoy comunica:
Estudante ausente, por favor, entre em contato com a secretaria da escola e realize a justificativa oficial de ausência.
Em caso de dúvidas favor entrar em contato nos telefones da secretaria da Escola.
Ficamos à disposição.
16 3324 4623  /   16 3324 2256    /   16 991190322
Obrigado.`}>
                              Entre em contato nos telefones da escola
                            </option>

                            <option value={`Olá ${item.responsavel},

Somos a Escola Letícia de Godoy e estamos entrando em contato para 
confirmar se você é o responsável pelo aluno(a) ${item.aluno}?

E. E. Profª. Letícia de Godoy comunica:
Estudante com número elevado de ausências, por favor, entre em contato com a secretaria da escola para conversar.
Em caso de dúvidas favor entrar em contato nos telefones da secretaria da Escola.
Ficamos à disposição.
16 3324 4623  /   16 3324 2256    /   16 991190322
Obrigado.`}>
                              Aluno com número elevado de ausências
                            </option>

                            <option value={`Olá ${item.responsavel},

Somos a Escola Letícia de Godoy e estamos entrando em contato para 
confirmar se você é o responsável pelo aluno(a) ${item.aluno}?

"E. E. Profª. Letícia de Godoy comunica:
Estudante chegou até a escola após o horário de entrada. Por favor, entre em contato com a secretaria da escola.
Ficamos à disposição.
16 3324 4623  /   16 3324 2256    /   16 991190322
Obrigado.`}>
                              Estudande chegou atrasado
                            </option>

                            <option value={`Olá ${item.responsavel},

Somos a Escola Letícia de Godoy e estamos entrando em contato para 
confirmar se você é o responsável pelo aluno(a) ${item.aluno}?

E. E. Profª. Letícia de Godoy comunica:
Estudante saiu mais cedo da escola na data de hoje. Salientamos a importância da permanência do estudante na escola e nas aulas. A saída antecipada deve ser fundamentada com motivo pertinente e não pode ser repetir mais de três vezes por bimestre. Ficamos abertos ao diálogo e orientações.
Qualquer dúvida, por favor, entre em contato com a secretaria da escola.
16 3324 4623  /   16 3324 2256    /   16 991190322
Obrigado.`}>
                              Estudante saiu mais cedo
                            </option>

                            <option value={`Olá ${item.responsavel},

Somos a Escola Letícia de Godoy e estamos entrando em contato para 
confirmar se você é o responsável pelo aluno(a) ${item.aluno}?

E. E. Profª. Letícia de Godoy comunica:
Estudante compareceu a escola sem o uso do uniforme que é obrigatório. Salientamos a importância do uso do uniforme e pedimos a colaboração da família nessa ação.
Qualquer dúvida, por favor, entre em contato com a secretaria da escola. Em caso de dificuldades, podemos ajudar.
16 3324 4623  /   16 3324 2256    /   16 991190322
Obrigado.`}>
                              Aluno sem uniforme
                            </option>

                            <option value={`Olá ${item.responsavel},

Somos a Escola Letícia de Godoy e estamos entrando em contato para 
confirmar se você é o responsável pelo aluno(a) ${item.aluno}?

E. E. Profª. Letícia de Godoy comunica:
Entramos em contato para solicitar uma reunião. 
Por favor, retorne, assim que possível, para a secretaria da escola. 
16 3324 4623  /   16 3324 2256    /   16 991190322
Obrigado.`}>
                              Solicitar uma reunião
                            </option>

                            <option value={`Olá ${item.responsavel},

Somos a Escola Letícia de Godoy e estamos entrando em contato para 
confirmar se você é o responsável pelo aluno(a) ${item.aluno}?

E. E. Profª. Letícia de Godoy comunica:
Entramos em contato para informar que a secretaria da escola está solicitando documentos do estudante para regularização da matrícula e dos documentos escolares. 
Por favor, retorne, assim que possível, para orientação. 
16 3324 4623  /   16 3324 2256    /   16 991190322
Obrigado.`}>
                              Solicitar documentos do estudante
                            </option>

                            <option value={`Olá ${item.responsavel},

Somos a Escola Letícia de Godoy e estamos entrando em contato para 
confirmar se você é o responsável pelo aluno(a) ${item.aluno}?

E. E. Profª. Letícia de Godoy comunica:
Entramos em contato para informar que o estudante recebeu orientações e medidas disciplinares. Será enviado documento, mas também ficamos à disposição para maiores esclarecimentos.
Em caso de dúvidas favor entrar em contato nos telefones da secretaria da Escola.
Ficamos à disposição.
16 3324 4623  /   16 3324 2256    /   16 991190322
Obrigado.`}>
                              Aluno recebeu orientações e medidas disciplinares
                            </option>

                          </select>
                        </div>
                      </section>    
                    </div>
                  ) : (
                    <div></div>
                  )}

                  {item.telefoneResponsavel && item.telefoneResponsavel !== 'inválido' ? (
                    <div className="width-100">

                      <section className="card-contato">

                        <div className="titulo">
                          <IonIcon icon={logoWhatsapp} />
                          <h1>Whatsapp</h1>
                        </div>

                        <div className="botoes">
                          <a onClick={() => abrirUrl(WhatsappLink)}>Enviar Mensagem</a>
                        </div>
                      </section>

                      <section className="card-contato">
                        <div className="titulo">
                          <IonIcon icon={chatboxOutline} />
                          <h1>SMS</h1>
                        </div>
                        <div className="botoes">
                          <a onClick={() => abrirUrl(SmsLink)}>Enviar Mensagem</a>
                        </div>
                      </section>

                      
                    </div>
                  ) : (
                    <div></div>
                  )}

                  {item.email && item.email !== 'inválido' ? (
                    <div className='width-100'>
                      <section className="card-contato">
                        <div className="titulo">
                          <IonIcon icon={mailOutline} />
                          <h1>E-mail</h1>
                        </div>
                        <div className="botoes">
                          <a onClick={() => abrirUrl(EmailLink)}>Enviar Mensagem</a>
                        </div>
                      </section>
                      <section className="card-contato">
                        <div className="titulo">
                          <IonIcon icon={logoGoogle} />
                          <h1>Gmail</h1>
                        </div>
                        <div className="botoes">
                          <a onClick={() => abrirUrl(GmailLink)}>Enviar Mensagem</a>
                        </div>
                      </section>
                    </div>
                  ) : (
                    <div></div>
                  )}
                  

                  </div>
                  );
                })
              ) : (
                <div className='width-100'>
                  <img src={require('../img/nao-encontrado.png')} alt="Erro" />
                  <h1>Dados não encontrados</h1>
                </div>
              )}
            </div>
          )}

          {!mdLerAlunos && !listaTelefone && !planilhas && !centralAtendimento && !formEnviarMensagemMassa && !todosOsAlunos && !aprovarMensagemDoProfessor && !aprovarMensagemDoResponsavel && !aprovarFotoDePerfil && !entrarEmContato && !abrirMensagem ? (
            <div className='width-100'>
              {paginaServicos && (
                <div className="width-100">

                  <section className='filtrar'>
                   <div className='btn'>
                      <div className='flex'>
                        <IonIcon icon={options} />
                        <p>Filtrar Ano</p>
                      </div>
                      <select defaultValue={ANO} onChange={(e) => localStorage.setItem('anoFiltrado', e.target.value)}>
                        <option value={Number(ANOnormal)}>{Number(ANOnormal)}</option>
                        <option value={Number(ANOnormal) + 1}>{Number(ANOnormal) + 1}</option>
                      </select>
                    </div>
                  </section>

                  <div style={{margin: '20px auto 10px auto'}} className="decoracao">
                      <p>Serviços</p>
                  </div>
                
                <div className="lista-chat">
                  <ul>
                    <li onClick={handleTodosOsAlunos}>
                      <IonIcon icon={people} />
                      <h1>Todos os alunos</h1>
                      <IonIcon icon={arrowForward} />
                    </li>
                    <li onClick={handleFormEnviarMensagemMassa}>
                      <IonIcon icon={chatbubbleEllipses} />
                      <h1>Enviar mensagem em massa</h1>
                      <IonIcon icon={arrowForward} />
                    </li>
                    <li onClick={handleCentralAtendimento}>
                      <IonIcon icon={IoniconsIcons.help} />
                      <h1>Central de atendimento</h1>
                      <IonIcon icon={arrowForward} />
                    </li>
                    <div style={{margin: '25px auto 25px auto'}} className="decoracao">
                      <p>Serviços Escolares</p>
                    </div>
                    <li onClick={handlePlanilhas}>
                      <IonIcon icon={IoniconsIcons.chatbubbles} />
                      <h1>Mensagem Rápida</h1>
                      <IonIcon icon={arrowForward} />
                    </li>
                    <li onClick={handleListaTelefone}>
                      <IonIcon icon={call} />
                      <h1>Lista de Telefones</h1>
                      <IonIcon icon={arrowForward} />
                    </li>
                    <div style={{margin: '25px auto 25px auto'}} className="decoracao">
                      <p>Chat do professor</p>
                    </div>
                    <li onClick={handleAprovarMensagemDoProfessor}>
                      <IonIcon icon={chatboxEllipses} />
                      <h1>Aprovar mensagem do professor</h1>
                      <IonIcon icon={arrowForward} />
                    </li>
                    <li onClick={handleAprovarMensagemDoResponsavel}>
                      <IonIcon icon={chatboxEllipses} />
                      <h1>Aprovar mensagem do responsável</h1>
                      <IonIcon icon={arrowForward} />
                    </li>
                    <div style={{margin: '25px auto 25px auto'}} className="decoracao">
                      <p>Carômetro</p>
                    </div>
                    <li onClick={handleAprovarFotoDePerfil}>
                      <IonIcon icon={image} />
                      <h1>Aprovar foto de perfil</h1>
                      <IonIcon icon={arrowForward} />
                    </li>
                  </ul>
                </div>

                <div className="width-100">

                  {alunos.length <= 0 ? (
                    <div className="width-100">
                      
                      <div style={{margin: '25px auto 10px auto'}}  className="decoracao">
                          <p>Séries</p>
                      </div>
                      
                      <div className="lista-chat">
                        <ul>
                          {lerSeries ? (
                            <div className='width-100'>
                              {series.length > 0 ? (
                                  series.map((serie, index) => (
                                      <li onClick={() => handleLerAlunos(serie)} key={index}>
                                        <IonIcon icon={peopleCircleOutline} />
                                        <h1>Série: {serie}</h1>
                                        <IonIcon icon={arrowForward} />
                                      </li>
                                  ))
                                  ) : (
                                    <div className="column">
                                    <h1>Nenhuma série disponível</h1>
                                    <a onClick={reload} className="btn-reload">Atualizar</a>
                                  </div>
                              )}
                            </div>
                          ) : !lerSeries ? (
                            <li onClick={handleLerSeries}>
                              <IonIcon icon={eye} />
                              <h1>Ler séries</h1>
                              <IonIcon icon={arrowForward} />
                            </li>
                          ) : (
                            <div></div>
                          )}
                          
                        </ul>
                      </div>
                    </div>
                  ) : !alunos.length ? (
                    <div className="width-100">
                      <div className="decoracao mt-35 mb-15">
                        <p>Alunos do {serie}</p>
                      </div>
                      <div className="column">
                        <h1>Nenhum aluno Encontrado</h1>
                      </div>
                    </div>
                  ) : (
                    <div></div>
                  )}

                </div>

              </div>
              )}
              
            </div>

          ) : (
            <div className='width-100'>
              
              {/* MOSTRAR PAGINAS DE SERVIÇOS */}

              
              {mdLerAlunos && (
                <>
                  {alunos.length > 0 ? (
                    <div className="width-100">
                      
                      <div className="decoracao mt-35 mb-10">
                        <p>Alunos do {serie}</p>
                      </div>

                      <div className="lista-chat">
                        <ul>
                            {alunos.map((aluno, index) => (
                                <li onClick={() => {
                                  handleGerenciarResponsavel(aluno.responsavel, aluno.serie, aluno.onesignalId);
                                  setBtnVoltarAlunosDaSerie(true);
                                  setBtnVoltarInicio(false);
                                }} key={index}>
                                  <IonIcon icon={personCircleOutline} />
                                  <div className="column">
                                    <h1>Responsável: {aluno.responsavel}</h1>
                                    <h1>Aluno(a): {aluno.aluno}</h1>
                                  </div>
                                  <IonIcon icon={arrowForward} />
                                </li>
                            ))}
                        </ul>
                      </div>
                    </div>
                  ) : !alunos.length ? (
                    <div className='width-100'>
                      <img src={require('../img/nao-encontrado.png')} alt="Erro" />
                      <h1>Nenhum Aluno do {serie} Encontrado</h1>
                    </div>
                  ) : (
                    <div></div>
                  )}
                </>  
              )}
              

              {aprovarMensagemDoProfessor && (
                <div className='aprovar-mensagem'>
                  
                  <div className='decoracao mt-30'>
                    <p>Aprovar mensagem</p>
                  </div>

                  {mensagensAprovar.length > 0 ? (
                    mensagensAprovar.map((dado) => (
                      <div className='card'>
                        <h1><strong>Do professor(a): </strong> {dado.usuario}</h1>
                        <h1><strong>Para o(a) responsável: </strong> {dado.responsavel}</h1>
                        <h1><strong>Aluno(a): </strong> {dado.aluno}</h1>
                        <p><strong>Mensagem: </strong> {dado.mensagem}</p>
                        <div className='space-between'>
                          <button className='verde' onClick={() => aceitarMensagemAprovar('professor', dado.serie, dado.responsavel, dado.mensagem, dado.usuario, dado.id, dado.onesignalId)}>
                            <p>Aceitar</p>
                          </button>
                          <button className='vermelho' onClick={() => rejeitarMensagemAprovar(dado.id)}>
                            <p>Rejeitar</p>
                          </button>  
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className='width-100 ps-relative'>
                      <img src={require('../img/nao-encontrado.png')} alt="Erro" />
                      <h1>Nenhuma mensagem encontrada</h1>
                    </div>
                  )}
                </div>
              )} 

              {aprovarMensagemDoResponsavel && (
                <div className='aprovar-mensagem'>
                  
                  <div className='decoracao mt-30'>
                    <p>Aprovar mensagem</p>
                  </div>

                  {mensagensAprovar.length > 0 ? (
                    mensagensAprovar.map((dado) => (
                      <div className='card'>
                        <h1><strong>Do(a) responsável: </strong> {dado.responsavel}</h1>
                        <h1><strong>Para os professores: </strong> Em geral</h1>
                        <h1><strong>Aluno(a): </strong> {dado.aluno}</h1>
                        <p><strong>Mensagem: </strong> {dado.mensagem}</p>
                        <div className='space-between'>
                          <button className='verde' onClick={() => aceitarMensagemAprovar('responsavel', dado.serie, dado.responsavel, dado.mensagem, dado.usuario, dado.id, dado.onesignalId)}>
                            <p>Aceitar</p>
                          </button>
                          <button className='vermelho' onClick={() => rejeitarMensagemAprovar(dado.id)}>
                            <p>Rejeitar</p>
                          </button>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className='width-100 ps-relative'>
                      <img src={require('../img/nao-encontrado.png')} alt="Erro" />
                      <h1>Nenhuma mensagem encontrada</h1>
                    </div>
                  )}
                </div>
              )} 

              {centralAtendimento && (
                <div className='central-atendimento'>
                  
                  <div className='decoracao mt-30'>
                    <p>Central de Atendimento</p>
                  </div>

                  {duvidasCentralAtendimento.length > 0 ? (
                    duvidasCentralAtendimento.map((duvida) => (
                      <div className='card'>
                        <h1>{duvida.usuario}</h1>
                        <p>{duvida.mensagem}</p>
                        <IonIcon onClick={() => excluirDuvida(duvida.id)} icon={trash} />
                      </div>
                    ))
                  ) : (
                    <div className='width-100'>
                      <img src={require('../img/nao-encontrado.png')} alt="Erro" />
                      <h1>Nenhuma dúvida encontrada</h1>
                    </div>
                  )}
                </div>
              )}
              
              {planilhas && (
                <div className='wd-100'>
                  
                  <div className='decoracao mt-35 mb-20'>
                    <p>Mensagem Rápida</p>
                  </div>

                  {!planilhasLer ? (
                    <div className="lista-chat">
                      <ul>
                        {dadosPlanilhas.length > 0 ? (
                            dadosPlanilhas.map((dado, index) => (
                              <li onClick={() => {
                                handleLerDadosPlanilhas(dado.json);
                                setBtnVoltarDadosDosAlunos(true);
                                setBtnVoltarInicio(false);
                              }} key={index}>
                                <IonIcon icon={peopleCircleOutline} />
                                <h1>Planilha: {dado.nome}</h1>
                                <IonIcon icon={arrowForward} />
                              </li>
                            ))
                        ) : (
                            <h1>Nenhuma planilha encontrada</h1>
                        )}
                      </ul>
                    </div>
                  ) : (
                    <div className='lista-chat'>

                      <section className="card-contato mt-20">
                        <div className="titulo">
                          <IonIcon icon={chatbubbleEllipses} />
                          <h1>Mensagem Rápida</h1>
                        </div>
                        <div className="botoes">
                          <select onChange={(e) => setMensagemRapida(e.target.value)}>
                            
                            <option value="">Escolha um mensagem</option>
                            
                            <option value={`Olá #responsavel,

Somos a Escola Letícia de Godoy e estamos entrando em contato para 
confirmar se você é o responsável pelo aluno(a) #aluno?

Informamos que o estudante #aluno, cujo responsável está vinculado a este número de telefone, não está presente hoje na escola. 
Caso haja alguma dúvida ou necessidade de informações adicionais, por favor, 
não hesite em entrar em contato com a secretaria da escola.`}>
                              Aluno não presente na escola
                            </option>

                            <option value={`Olá #responsavel,

Somos a Escola Letícia de Godoy e estamos entrando em contato para 
confirmar se você é o responsável pelo aluno(a) #aluno?

E. E. Profª. Letícia de Godoy comunica:
Tentamos entrar em contato sem sucesso, assim que possível, favor retornar através dos telefones da secretaria.
16 3324 4623  /   16 3324 2256    /   16 991190322
Obrigado.`}>
                              Contato sem sucesso
                            </option>

                            <option value={`Olá #responsavel,

Somos a Escola Letícia de Godoy e estamos entrando em contato para 
confirmar se você é o responsável pelo aluno(a) #aluno?

E. E. Profª. Letícia de Godoy comunica:
Recado enviado através do estudante, favor verificar o documento. 
Em caso de dúvidas estamos à disposição.
16 3324 4623  /   16 3324 2256    /   16 991190322
Obrigado.`}>
                              Documento enviado através do aluno
                            </option>

                            <option value={`Olá #responsavel,

Somos a Escola Letícia de Godoy e estamos entrando em contato para 
confirmar se você é o responsável pelo aluno(a) #aluno?

E. E. Profª. Letícia de Godoy comunica:
Estudante ausente, por favor, entre em contato com a secretaria da escola e realize a justificativa oficial de ausência.
Em caso de dúvidas favor entrar em contato nos telefones da secretaria da Escola.
Ficamos à disposição.
16 3324 4623  /   16 3324 2256    /   16 991190322
Obrigado.`}>
                              Entre em contato nos telefones da escola
                            </option>

                            <option value={`Olá #responsavel,

Somos a Escola Letícia de Godoy e estamos entrando em contato para 
confirmar se você é o responsável pelo aluno(a) #aluno?

E. E. Profª. Letícia de Godoy comunica:
Estudante com número elevado de ausências, por favor, entre em contato com a secretaria da escola para conversar.
Em caso de dúvidas favor entrar em contato nos telefones da secretaria da Escola.
Ficamos à disposição.
16 3324 4623  /   16 3324 2256    /   16 991190322
Obrigado.`}>
                              Aluno com número elevado de ausências
                            </option>

                            <option value={`Olá #responsavel,

Somos a Escola Letícia de Godoy e estamos entrando em contato para 
confirmar se você é o responsável pelo aluno(a) #aluno?

E. E. Profª. Letícia de Godoy comunica:
Estudante chegou até a escola após o horário de entrada. Por favor, entre em contato com a secretaria da escola.
Ficamos à disposição.
16 3324 4623  /   16 3324 2256    /   16 991190322
Obrigado.`}>
                              Estudande chegou atrasado
                            </option>

                            <option value={`Olá #responsavel,

Somos a Escola Letícia de Godoy e estamos entrando em contato para 
confirmar se você é o responsável pelo aluno(a) #aluno?

E. E. Profª. Letícia de Godoy comunica:
Estudante saiu mais cedo da escola na data de hoje. Salientamos a importância da permanência do estudante na escola e nas aulas. A saída antecipada deve ser fundamentada com motivo pertinente e não pode ser repetir mais de três vezes por bimestre. Ficamos abertos ao diálogo e orientações.
Qualquer dúvida, por favor, entre em contato com a secretaria da escola.
16 3324 4623  /   16 3324 2256    /   16 991190322
Obrigado.`}>
                              Estudante saiu mais cedo
                            </option>

                            <option value={`Olá #responsavel,

Somos a Escola Letícia de Godoy e estamos entrando em contato para 
confirmar se você é o responsável pelo aluno(a) #aluno?

E. E. Profª. Letícia de Godoy comunica:
Estudante compareceu a escola sem o uso do uniforme que é obrigatório. Salientamos a importância do uso do uniforme e pedimos a colaboração da família nessa ação.
Qualquer dúvida, por favor, entre em contato com a secretaria da escola. Em caso de dificuldades, podemos ajudar.
16 3324 4623  /   16 3324 2256    /   16 991190322
Obrigado.`}>
                              Aluno sem uniforme
                            </option>

                            <option value={`Olá #responsavel,

Somos a Escola Letícia de Godoy e estamos entrando em contato para 
confirmar se você é o responsável pelo aluno(a) #aluno?

E. E. Profª. Letícia de Godoy comunica:
Entramos em contato para solicitar uma reunião. 
Por favor, retorne, assim que possível, para a secretaria da escola. 
16 3324 4623  /   16 3324 2256    /   16 991190322
Obrigado.`}>
                              Solicitar uma reunião
                            </option>

                            <option value={`Olá #responsavel,

Somos a Escola Letícia de Godoy e estamos entrando em contato para 
confirmar se você é o responsável pelo aluno(a) #aluno?

E. E. Profª. Letícia de Godoy comunica:
Entramos em contato para informar que a secretaria da escola está solicitando documentos do estudante para regularização da matrícula e dos documentos escolares. 
Por favor, retorne, assim que possível, para orientação. 
16 3324 4623  /   16 3324 2256    /   16 991190322
Obrigado.`}>
                              Solicitar documentos do estudante
                            </option>

                            <option value={`Olá #responsavel,

Somos a Escola Letícia de Godoy e estamos entrando em contato para 
confirmar se você é o responsável pelo aluno(a) #aluno?

E. E. Profª. Letícia de Godoy comunica:
Entramos em contato para informar que o estudante recebeu orientações e medidas disciplinares. Será enviado documento, mas também ficamos à disposição para maiores esclarecimentos.
Em caso de dúvidas favor entrar em contato nos telefones da secretaria da Escola.
Ficamos à disposição.
16 3324 4623  /   16 3324 2256    /   16 991190322
Obrigado.`}>
                              Aluno recebeu orientações e medidas disciplinares
                            </option>

                          </select>
                        </div>
                      </section>

                      <div className='decoracao mt-35 mb-20'>
                        <p>Filtrar Dados</p>
                      </div>

                      <div className='form-tecvit'>
                        
                        <div className="flex wd-100 mt-10">
                          <select value={buscaResponsabilidade} onChange={(e) => setBuscaResponsabilidade(e.target.value)}>
                            <option value="">Selecione..</option>
                            <option value="mãe">Mãe</option>
                            <option value="pai">Pai</option>
                          </select>
                          <label>Responsabilidade</label>
                        </div>

                        <div className="flex wd-100 mt-10">
                          <input value={buscaAluno} onChange={(e) => setBuscaAluno(e.target.value)} type='text' placeholder=' '/>
                          <label>Buscar Aluno</label>
                        </div>

                        <div className="flex wd-100 mt-10 mb-0">
                          <input value={buscaDados} onChange={(e) => setBuscaDados(e.target.value)} type='text' placeholder=' '/>
                          <label>Buscar Dados em Geral</label>
                        </div>
                        
                      </div>

                      <div className='decoracao mt-35 mb-20'>
                        <p>Planilhas</p>
                      </div>
                      
                      <ul>
                      {dadosPlanilhas.length > 0 ? (
                        dadosPlanilhas.filter(dado => {
                            const dadoString = JSON.stringify(dado).toLowerCase().replace(/\u0083/g, '');
                            return dadoString.includes(buscaDados.toLowerCase()) && dadoString.includes(buscaResponsabilidade.toLowerCase()) && dadoString.includes(buscaAluno.toLowerCase());
                          }).map((dado, index) => {
                            var aluno = '';
                            var responsavel = '';

                            return (
                              <li className='dados'>
                                {Object.entries(dado).map(([nome, valor]) => {
                                    
                                    if (nome.toLowerCase().includes('aluno')) {
                                      aluno = valor;
                                    }
                                    if (nome.toLowerCase() === 'responsável' || nome.toLowerCase() === 'responsavel' || nome.toLowerCase() === 'responsã¡vel') {
                                      responsavel = valor;
                                    }
                                    
                                    
                                    if (nome === 'E-mail' || nome === 'email' || nome === 'e-mail' || nome === 'EMAIL' || nome === 'E-MAIL') {
                                        return (
                                          <div className='wd-100 flex column'>
                                            <button className="laranja email" onClick={ async () => {
                                              const novaMensagem = await atualizarMensagemRapida(aluno, responsavel);
                                              abrirUrl(`mailto:${valor}?subject=Mensagem da Escola Letícia de Godoy Bueno Carvalho Lopes&?body=${encodeURIComponent(novaMensagem)}`);
                                            }}>
                                              <p>
                                                <IonIcon icon={mail} /> 
                                                Email: {valor}
                                              </p>
                                            </button>
                                            <button className="laranja email" onClick={ async () => {
                                              const novaMensagem = await atualizarMensagemRapida(aluno, responsavel);
                                              abrirUrl(`https://mail.google.com/mail/u/0/?fs=1&tf=cm&source=mailto&su=Mensagem+da+Escola+Let%C3%ADcia+de+Godoy+Bueno+Carvalho+Lopes&to=${valor}&body=${encodeURIComponent(novaMensagem)}`)
                                            }}>
                                              <p>
                                                <IonIcon icon={logoGoogle} /> 
                                                Gmail: {valor}
                                              </p>
                                            </button>
                                          </div>
                                        );
                                    } else if (nome.includes('telefone') || nome.includes('Telefone')) {
                                        const telefones = valor.toString().split(/\s+/);
                                        const tamanho = telefones.length;
                                        if (tamanho === 1) {
                                            return (
                                              <div className='wd-100 flex column'>
                                                <button className="azul" onClick={() => abrirUrl(`tel:${valor.toString().replace(/[()\s\-.\u00A0]/g, '')}`)}>
                                                  <p>
                                                    <IonIcon icon={call} /> 
                                                    Telefone: {valor.toString().replace(/[()\s\-.\u00A0]/g, '')}
                                                  </p>
                                                </button>
                                                <button className="azul-escuro" onClick={ async () => {
                                                  const novaMensagem = await atualizarMensagemRapida(aluno, responsavel);
                                                  abrirUrl(`sms://${valor.toString().replace(/[()\s\-.\u00A0]/g, '')}?body=${encodeURIComponent(novaMensagem)}`)
                                                }}>
                                                  <p>
                                                    <IonIcon icon={chatboxEllipses} /> 
                                                    Sms: {valor.toString().replace(/[()\s\-.\u00A0]/g, '')}
                                                  </p>
                                                </button>
                                                <button className="verde" onClick={ async () => {
                                                  const novaMensagem = await atualizarMensagemRapida(aluno, responsavel);
                                                  abrirUrl(`https://wa.me/${valor.toString().replace(/[()-]/g, '')}?text=${encodeURIComponent(novaMensagem)}`);
                                                }}>
                                                  <p>
                                                    <IonIcon icon={logoWhatsapp} /> 
                                                    Whatsapp {valor.toString().replace(/[()\s\-.\u00A0]/g, '')}
                                                  </p>
                                                </button>
                                              </div>
                                            );
                                        } else if (tamanho > 1) {
                                            return (
                                                telefones.map((tel) => (
                                                  <div className='wd-100 flex column'>
                                                    <button className="azul" onClick={() => abrirUrl(`tel:${tel.toString().replace(/[-]/g, '')}`)}>
                                                      <p>
                                                        <IonIcon icon={call} /> 
                                                        Telefone: {tel.toString().replace(/[-]/g, '')}
                                                      </p>
                                                    </button>
                                                    <button className="azul-escuro" onClick={ async () => {
                                                      const novaMensagem = await atualizarMensagemRapida(aluno, responsavel);
                                                      abrirUrl(`sms://${tel.toString().replace(/[-]/g, '')}?body=${encodeURIComponent(novaMensagem)}`)
                                                    }}><p>
                                                        <IonIcon icon={chatboxEllipses} /> 
                                                        Sms: {tel.toString().replace(/[-]/g, '')}
                                                      </p>
                                                    </button>
                                                    <button className="verde" onClick={ async () => {
                                                      const novaMensagem = await atualizarMensagemRapida(aluno, responsavel);
                                                      abrirUrl(`https://wa.me/${tel.toString().replace(/[()-]/g, '')}?text=${encodeURIComponent(novaMensagem)}`);
                                                    }}>
                                                      <p>
                                                        <IonIcon icon={logoWhatsapp} /> 
                                                        Whatsapp {tel.toString().replace(/[-]/g, '')}
                                                      </p>
                                                    </button>
                                                  </div>
                                                ))
                                            );
                                        }
                                        
                                    }
                                    return (
                                        <h1><strong>{nome}:</strong> {valor}</h1>
                                    );
                                })}

                            </li>
                          );
                        })
                        ) : (
                            <h1>Nenhum dado encontrado</h1>
                        )}
                      </ul>
                    </div>
                  )}
                  
                </div>
              )}

              {listaTelefone && (
                <div className='wd-100'>
                  
                  {!listaTelefoneLer ? (
                    <div className="lista-chat mt-0">

                      <div className='decoracao mt-40 mb-30'>
                        <p>Telefones</p>
                      </div>

                      <ul className='mt-0'>
                        {dadosListaTelefone.length > 0 ? (
                            dadosListaTelefone.map((objeto, index) => {
                              
                              const nomeSerie = Object.keys(objeto)[0]; // Assume-se que cada objeto tenha apenas uma chave
                              const dadosDaSerie = objeto[nomeSerie];
                              
                              
                              return (
                                <li onClick={() => {
                                  handleLerDadosListaTelefone(nomeSerie, dadosDaSerie);
                                  setBtnVoltarListaDeTelefones(true);
                                  setBtnVoltarInicio(false);
                                }} key={index}>
                                  <IonIcon icon={peopleCircleOutline} />
                                  <h1>Planilha: {nomeSerie}</h1>
                                  <IonIcon icon={arrowForward} />
                                </li>
                              )
                            
                            })
                        ) : (
                            <h1>Nenhum dado encontrado</h1>
                        )}
                      </ul>
                    </div>
                  ) : (
                    <div className='lista-chat'>
                      
                      <div className='decoracao mt-40 mb-35'>
                        <p>Telefones do {gerenciarSerie}</p>
                      </div>

                      <table className='tabela-telefones mg-auto'>
                        {dadosListaTelefone.length > 0 ? (
                          <>
                            {dadosListaTelefone.map((dado) => (
                              <div className='wd-100 mb-30'>
                                <tr>
                                  <td className='principal'>Responsável</td>
                                  <td>{dado.responsavel}</td>
                                </tr>
                                <tr>
                                  <td className='principal'>Aluno(a)</td>
                                  <td>{dado.aluno}</td>
                                </tr>
                                <tr>
                                  <td className='principal'>Telefones</td>
                                  <td>{dado.telefone}</td>
                                </tr>
                                <tr>
                                  <td className='principal'>Emails</td>
                                  <td className='email'>{dado.email}</td>
                                </tr>
                                <tr>
                                </tr>
                              </div>
                            ))}
                          </>
                        ) : (
                          <h1>Nenhum telefone encontrado!</h1>
                        )}
                      </table>

                    </div>
                  )}
                  
                </div>
              )}

              {aprovarFotoDePerfil && (
                <div className='aprovar-mensagem'>
                  
                  <div className='decoracao mt-30'>
                    <p>Aprovar fotos de perfil</p>
                  </div>

                  {fotosAprovar.length > 0 ? (
                    fotosAprovar.map((dado) => (
                      <div className='card'>
                        <h1><strong>Responsável: </strong> {dado.responsavel}</h1>
                        <img src={dado.urlImagem} alt={dado.nomeImagem} />
                        <div className='space-between'>
                          <button className='verde' onClick={() => aceitarFotoDePerfil(dado.responsavel, dado.nomeImagem)}>
                            <p>Aceitar</p>
                          </button>
                          <button className='vermelho' onClick={() => rejeitarFotoDePerfil(dado.responsavel, dado.nomeImagem)}>
                            <p>Rejeitar</p>
                          </button>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className='width-100'>
                      <img src={require('../img/nao-encontrado.png')} alt="Erro" />
                      <h1 className='mt-0'>Nenhuma foto de perfil pendente</h1>
                    </div>
                  )}
                </div>
              )}
              
              {formEnviarMensagemMassa && (
                <div className='form-tecvit formMensagemEmMassa'>
                  
                  <div className='decoracao mt-20 mb-30'>
                    <p>Mensagem em Massa</p>
                  </div>

                  <div className='flex'>
                    <select onChange={(e) => setDestinatario(e.target.value)}>
                      <option value="" selected >Escolha um destinatário</option>
                      <option value="todos">Todos</option>
                      <option value="1º">1ºANO</option>
                      <option value="2º">2ºANO</option>
                      <option value="3º">3ºANO</option>
                      <option value="outros">Outros</option>
                    </select>
                    <label>Destinátario</label>
                  </div>

                  {destinatario === 'outros' ? (
                    <div style={{width: '103.5%'}}>

                      <FormEnviarMensagemEmMassa />

                    </div>
                  ) : (
                    <div className='wd-100'>
                      
                      <div className='flex'>
                        <textarea placeholder=" " onChange={(e) => setMensagemEmMassa(e.target.value)}></textarea>
                        <label>Mensagem</label>
                      </div>

                      <div className='flex mt-30'>
                        <button onClick={handleEnviarMensagemEmMassa}>Enviar Mensagem</button>
                      </div>

                    </div>
                  )}



                </div>
              )}

              {todosOsAlunos && !abrirMensagem && !entrarEmContato ? (
                <div className='lista-chat'>
                  
                  <div className='decoracao mt-35 mb-10'>
                    <p>Pesquisar Aluno</p>
                  </div>

                  <div className='form-tecvit'>
                    <div style={{width: '100%', margin: '15px auto 0px auto'}} className='flex'>
                      <input value={buscaAluno} onChange={(e) => setBuscaAluno(e.target.value)} type='text' placeholder=' '/>
                      <label>Buscar Aluno</label>
                    </div>
                  </div>

                  <div style={{margin: '25px auto 10px auto'}} className='decoracao'>
                    <p>Todos os Alunos</p>
                  </div>

                  <ul>
                    {todosAlunos.length > 0 ? (
                      todosAlunos.filter(aluno => aluno.aluno.toLowerCase().includes(buscaAluno.toLowerCase()))
                      .map((aluno, index) => (
                        <li style={{padding: '10px 0px 10px 10px'}} onClick={() => {
                          handleGerenciarResponsavel(aluno.responsavel, aluno.serie, aluno.onesignalId);
                          setBtnVoltarTodosOsAlunos(true);
                          setBtnVoltarInicio(false);
                        }} key={index}>
                          <div className="column">
                            <h1>Responsável: {aluno.responsavel}</h1>
                            <h1>Aluno(a): {aluno.aluno}</h1>
                            <h1>Série: {aluno.serie}</h1>
                          </div>
                          <IonIcon icon={arrowForward} />
                        </li>
                      ))
                    ) : (
                      <div className='width-100'>
                        <img src={require('../img/nao-encontrado.png')} alt="Erro" />
                        <h1>Nenhum Aluno Encontrado</h1>
                      </div>
                    )}
                  </ul>

                </div>
              ) : (
                <div></div>
              )} 

            </div>
          )}
          

          

        </section>
      ) : !paginaMensagemDoProfessor ? (
        <section className='content-chat'>
          {/* CONTEUDO PARA PROFESSOR */}
          
          {!abrirFormMensagemProfessor ? (
            <div className='wd-100'>
              {paginaServicos && (
                <div className="wd-100">
                  <div className="decoracao mt-35 mb-10">
                      <p>Serviços</p>
                  </div>
                
                <div className="lista-chat">
                  <ul>
                    <li onClick={() => {
                      handleFormMensagemProfessor();
                      setBtnVoltarInicioProfessor(true);
                      setBtnVoltarInicio(false);
                    }}>
                        <IonIcon icon={chatboxEllipses} />
                        <h1>Enviar Mensagem para Aluno</h1>
                        <IonIcon icon={arrowForward} />
                    </li>
                  </ul>
                </div>
              </div>
              )}

              <div className="wd-100">

                {alunos.length <= 0 ? (
                  <div className="wd-100">
                    
                    <div className="decoracao mt-25 mb-10">
                        <p>Séries</p>
                    </div>
                    
                    <div className="lista-chat">
                      <ul>
                        {lerSeries ? (
                          <div className='width-100'>
                            {series.length > 0 ? (
                                series.map((serie, index) => (
                                    <li onClick={() => {
                                      handleLerAlunos(serie);
                                      setPaginaServicos(false);
                                      setBtnVoltarInicioProfessor(true);
                                      setBtnVoltarInicio(false);
                                    }} key={index}>
                                      <IonIcon icon={peopleCircleOutline} />
                                      <h1>Série: {serie}</h1>
                                      <IonIcon icon={arrowForward} />
                                    </li>
                                ))
                                ) : (
                                  <div className="column">
                                    <h1>Nenhuma série disponível</h1>
                                    <a onClick={reload} className="btn-reload">Atualizar</a>
                                  </div>
                            )}
                          </div>
                        ) : !lerSeries ? (
                          <li onClick={handleLerSeries}>
                            <IonIcon icon={eye} />
                            <h1>Ler séries</h1>
                            <IonIcon icon={arrowForward} />
                          </li>
                        ) : (
                          <div></div>
                        )}
                        
                      </ul>
                    </div>
                  </div>
                ) : !alunos.length ? (
                  <div className="width-100">

                    <div className="decoracao mt-35 mb-15">
                      <p>Alunos do {serie}</p>
                    </div>
                    
                    <div className="column">
                      <h1>Nenhum aluno Encontrado</h1>
                    </div>

                  </div>
                ) : (
                  <div></div>
                )}

                {alunos.length > 0 && abrirLerAlunos ? (
                  <div className="wd-100">
                    
                    <div className="decoracao mt-35 mb-10">
                      <p>Alunos do {serie}</p>
                    </div>

                    <div className="lista-chat">
                      <ul>
                        {alunos.map((aluno, index) => (
                          <li onClick={() => {
                            handleAbrirMensagemProfessor(aluno.responsavel, aluno.serie, 'professor');
                            setBtnVoltarInicioProfessor(false);
                            setBtnVoltarInicio(false);
                            setBtnVoltarAlunosDaSerieProfessor(true);
                         }} key={index}>
                            <IonIcon icon={personCircleOutline} />
                            <div className="column">
                              <h1>Responsável: {aluno.responsavel}</h1>
                              <h1>Aluno(a): {aluno.aluno}</h1>
                            </div>
                            <IonIcon icon={arrowForward} />
                          </li>
                        ))}
                      </ul>
                    </div>

                  </div>
                ) : (
                  <div></div>
                )}

              </div>
            </div>
          ) : (
            <div className='wd-100'>
              {abrirFormMensagemProfessor && (
                <div className='wd-92-5 mg-auto'>
            
                  <FormEnviarMensagemParaAlunos />
                  
                </div>
              )}
            </div>
          )}
          
        </section>
      ) : (
        <div></div>
      )}

      {popupGerenciar && (
        <div>
          <div className="fundo"></div>
          <div className="popup-gerenciar">
            <h1>Gerenciar dados do(a) {gerenciarResponsavel}</h1>
            <button onClick={() => handleEntrarEmContato(gerenciarResponsavel)}>Entrar em Contato</button>
            <button onClick={() => handleAbrirMensagem(gerenciarResponsavel, gerenciarSerie, logado)}>Abrir Mensagens</button>
            <button onClick={() => handleExcluirResponsavel(gerenciarResponsavel, gerenciarSerie)}>Excluir Responsável</button>
            <button onClick={() => {
              handleFecharGerenciarResponsavel();
              setBtnVoltarInicio(true);
              setBtnVoltarAlunosDaSerie(false);
              setBtnVoltarTodosOsAlunos(false);
            }} className="fechar">Fechar</button>
          </div>
        </div>
      )}
          
          <div style={{margin: '0px'}} className='width-100'>
            {abrirMensagem && (
              <div className='container-mensagens'>
                <section className="mensagens">
                  
                  {mensagensOnline && mensagensOnline.length > 0 ? (
                    mensagensOnline.map((dado, index) => {
                      if (logado === 'responsavel') {
                        return (
                          <div className={`mensagem ${dado.usuario === dado.servidor ? 'dele' : 'minha'}`}>
                            <div className='paragrafo'>
                              {dado.mensagem}
                            </div>
                            <p>{dado.hora}</p>
                          </div>
                        );
                      } else {
                        return (
                          <div className={`mensagem ${dado.usuario === dado.servidor ? 'minha' : 'dele'}`}>
                            <div className='paragrafo'>
                              {dado.mensagem}
                            </div>
                            <p>{dado.hora}</p>
                          </div>
                        );
                      }
                  })
                  ) : (
                    <>
                      {carregamentoMensagem ? (
                        <section className='carregamento-mensagens'>
                          <span className='bola'></span>
                          <h1>Carregando..</h1>
                        </section>
                      ) : mensagensOnline.length === 0 ? (
                        <div className='width-100 ps-relative'>
                          <img src={require('../img/nao-encontrado.png')} alt="Erro" />
                          <h1 style={{textAlign: 'center'}}>Nenhuma Mensagem Encontrada</h1>
                        </div>
                      ) : (
                        <></>
                      )}
                    </>
                  )}
                  
                  
                </section>
                
                <section className="input-mensagens">
                  <textarea value={mensagem} onChange={(e) => setMensagem(e.target.value)} placeholder='Mensagem'></textarea>
                  {logado === 'responsavel' ? (
                    <IonIcon onClick={() => {
                      handleEnviarMensagemParaServidor();
                      setMensagem('');
                    }} 
                    icon={paperPlaneOutline} 
                    />
                  ) : (
                    <IonIcon onClick={() => {
                      handleEnviarMensagemParaResponsavel();
                      setMensagem('');
                    }} 
                    icon={paperPlaneOutline} 
                    />
                  )}
                </section>
              </div>
            )}

            {abrirMensagemProfessor && (
              <div className='container-mensagens container-mensagens-professor'>
                <section className="mensagens">
                  <h1>Comunicados dos Professores</h1>
                  <p>
                    O sistema de mensagens entre os professores opera como um canal informativo controlado,
                    destaca-se que o funcionamento do chat está sujeito à aprovação adicional da direção, 
                    visando evitar discussões paralelas ou tópicos desconfortáveis, assegurando assim um fluxo 
                    de informações organizado e acessível a todos os alunos.
                  </p>

                  <div className='decoracao'>
                    <p>Comunicados</p>
                  </div>

                  {mensagensOnline.length > 0 ? (
                    mensagensOnline.map((dado, index) => {
                      if (logado === 'responsavel') {
                        return (
                          <div className={`mensagem ${dado.servidor === 'responsavel' ? 'minha' : 'dele'}`}>
                            <div className='paragrafo'>
                              <strong>{dado.usuario}: </strong> {dado.mensagem}
                            </div>
                            <p>{dado.hora}</p>
                          </div>
                        );
                      } else {
                        return (
                          <div className={`mensagem ${dado.servidor === 'professor' ? 'minha' : 'dele'}`}>
                            <div className='paragrafo'>
                              <strong>{dado.usuario}: </strong> {dado.mensagem}
                            </div>
                            <p>{dado.hora}</p>
                          </div>
                        );
                      }
                  })
                  ) : (
                    <div className='width-100'>
                      <img src={require('../img/nao-encontrado.png')} alt="Erro" />
                      <h1 style={{textAlign: 'center'}}>Nenhum comunicado encontrado</h1>
                    </div>
                  )}
                  
                </section>
                
              </div>
            )}

          </div>

    </main>
  );
};


export default Chat;